<template>
  <section class="content mt-5">
    <mdb-container>
      <mdb-row>
        <mdb-col col="12" class="text-left">
          <UserPolicyContent/>
        </mdb-col>
      </mdb-row>
    </mdb-container>
  </section>
</template>

<script>
import UserPolicyContent from '@/components/molecules/UserPolicyContent'

export default {
  name: 'UserPolicy',
  components: {
    UserPolicyContent
  },
}
</script>
